module.exports = __webpack_public_path__ + "img/rgmm.cc9883e1.png";